import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  fetchAllCategories,
  fetchAllQuestionTypes,
  fetchQuestionStatus,
  fetchAllDepartments,
} from 'actions/utils';

import Mapping from 'containers/Manage-Questionnaire/Mapping';
import PrescreenTable from 'containers/Manage-Questionnaire/prescreen/PrescreenTable';
import QuestionnaireTable from 'containers/Manage-Questionnaire/questionnaire/QuestionnaireTable';
import Metadata from 'containers/Manage-Questionnaire/manage-metadata/Metadata';
import ArchiveTable from 'containers/Manage-Questionnaire/archive/ArchiveTable';

import { QuestionnaireManagementHeader } from 'components/forms/questionnaire-management/header';
import Loading from 'components/loading';
import { Container } from 'components/styled-components';
import colors from 'utils/colors';

import styled from 'styled-components';
import concat from 'lodash/concat';

class QuestionnaireManagement extends Component {
  state = {
    active: 0,
  };

  componentDidMount() {
    this.props.fetchAllQuestionTypes();
    this.props.fetchAllCategories();
    this.props.fetchQuestionStatus();
	this.props.fetchAllDepartments();
  }

  handleChangeActive = active => {
    this.setState({ active });
  };

  render() {
    const { active } = this.state;
    return (
      <Container>
        <HeadingWrapper>
          <QuestionnaireManagementHeader
            handleChangeActive={this.handleChangeActive}
            active={active}
            handlePublish={this.handlePublish}
            questions={concat(
              this.props.prescreenQuestions,
              this.props.questionnaireQuestions
            )}
            appUser={this.props.appUser}
          />
        </HeadingWrapper>
        {this.props.isFetching ? (
          <Loading size={100} />
        ) : (
          <Wrapper>
            {active === 0 && <PrescreenTable />}
            {active === 1 && <QuestionnaireTable />}
            {active === 2 && <Mapping />}
            {active === 3 && (
              <ArchiveTable
                categories={this.props.categories}
                questionTypes={this.props.questionTypes}
              />
            )}
            {active === 4 && (
              <Metadata
                categories={this.props.categories}
                questionTypes={this.props.questionTypes}
                {...this.props}
              />
            )}
          </Wrapper>
        )}
      </Container>
    );
  }
}

const HeadingWrapper = styled.div`
  border-bottom: 1px solid ${colors.lightestGray};
  margin-bottom: 1rem;
`;

const Wrapper = styled.div`
  padding: 0rem 1rem 1rem;
`;

const mapStateToProps = state => ({
  questionTypes: state.utils.questionTypes,
  categories: state.utils.categories,
  isFetchingCategories: state.utils.isFetchingCategories,
  isFetchingTypes: state.utils.isFetchingTypes,
  questionStatus: state.utils.questionStatus,
  appUser: state.auth.appUser,
  departments: state.utils.departments,
});

QuestionnaireManagement = connect(
  mapStateToProps,
  {
    fetchAllQuestionTypes,
    fetchAllCategories,
    fetchQuestionStatus,
	fetchAllDepartments,
  }
)(QuestionnaireManagement);

export default QuestionnaireManagement;
